// extracted by mini-css-extract-plugin
export default {"alignLeft":"page-table_alignLeft__s5f7k","noPadding":"page-table_noPadding__MrUnJ","noData":"page-table_noData__WswRu"};